import { useEffect, useState } from 'react'

const useVisibleElement = (targetElement: string) => {
  const [elementIsVisible, setElementIsVisible] = useState(false)
  const [elementPosition, setElementPosition] = useState<DOMRect>()
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    const $targetElement = document.querySelector(targetElement)

    if (!$targetElement) return
    if (isReady) return

    setIsReady(true)
    setElementPosition(document.querySelector(targetElement)?.getBoundingClientRect())

    const observer = new IntersectionObserver(
      (entries) => (entries[0].isIntersecting === true ? setElementIsVisible(true) : setElementIsVisible(false)),
      { threshold: [0] },
    )

    observer.observe($targetElement)

    return () => {
      observer.unobserve($targetElement)
    }
  }, [targetElement])

  return [elementIsVisible, elementPosition]
}

export default useVisibleElement
